/* eslint-disable import/prefer-default-export */
export enum NotificationMethods {
    Aplicacao = 'APP',
    Email = 'EMAIL',
}
